/**
 * Text for the inspector card line that identifies who or what placed the student in the queue.
 * A filled device name occupies the line. The inspector login is used when the device name is empty.
 *
 * @param {Object|null|undefined} student Student payload shown on the card.
 * @returns {string}
 */
export function deviceCallerLabel(student) {
    if (!student) {
        return "";
    }

    const deviceName = normalizeLabel(student.device_name);
    if (deviceName !== "") {
        return deviceName;
    }

    const inspector = student.inspectorQrCode;
    if (inspector && typeof inspector === "object") {
        return normalizeLabel(inspector.name);
    }

    return "";
}

/**
 * Trim a card label and treat missing values as an empty string.
 *
 * @param {*} value Raw label from the queue payload.
 * @returns {string}
 */
function normalizeLabel(value) {
    if (value === null || value === undefined) {
        return "";
    }

    return String(value).trim();
}
